module.exports = __webpack_public_path__ + "static/media/gridia.f049d981.svg";